<div class="header">
	<logo
		class="header__logo"
		(click)="redirectTo('/calendar', 'calendar')"
	></logo>
	<div class="zk-flex zk-gap-2">
		<a
			class="header__clari"
			href="#"
			rel="noopener"
			(click)="openClariAndTrack()"
		>
			✨ ClariPro
		</a>
		<freud-tab-menu
			[(items)]="desktopMenu"
			[activeItem]="currentRoute"
			[bgColor]="true"
		></freud-tab-menu>
		<div class="header__menu">
			<faq-menu class="zk-mr-1 md:zk-mr-3"></faq-menu>
			<div
				class="header__chat zk-mr-1 md:zk-mr-3"
				[ngClass]="{'unread-chat':  this.chatService.hasUnreadConversations }"
				freud-tooltip
				tooltipLabel="Chat"
				tabindex="0"
				tooltipPosition="bottom"
				(click)="openChat()"
				(keydown.enter)="openChat()"
			>
				<span class="freud-icon freud-icon-messages freud-icon-md"></span>
			</div>
			<notifications-menu></notifications-menu>
			<div class="header__avatar-wrapper">
				<user-avatar
					class="header__avatar"
					(click)="toggleSubMenu(!isSubMenuOpen)"
					(keydown.enter)="toggleSubMenu(true)"
					(keydown.esc)="toggleSubMenu(false)"
					[isUserVisible]="isUserVisible"
					[user]="userData"
				></user-avatar>
				<overlay [isActive]="isSubMenuOpen">
					<header-submenu
						class="header__submenu"
						(onClose)="toggleSubMenu(false)"
						(onChangeStatus)="changeStatus($event)"
						[userData]="userData"
						[isUserVisible]="isUserVisible"
						[isUserPremium]="userIsPremium"
						[isUserActive]="isUserActive"
						*ngIf="isSubMenuOpen"
					></header-submenu>
				</overlay>
			</div>
		</div>
	</div>
</div>
